export default "__VITE_ASSET__D0c$b2OX__"